export default __webpack_public_path__ + "static/media/16.715367c9.jpeg";